module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_1001365.61d15726.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/ift/InternetSatF/FormatoSimplificado_1001365.pdf
// module id = 349
// module chunks = 0